<!-- LEGENDS -->
<div class="d-flex align-items-center justify-content-start me-auto">
  <div class="d-flex flex-column">
    <div class="my-2">
      <span class="fs-6 fw-bold">Legend information</span>
    </div>
    @for (label of labels; track label) {
      <div class="d-flex flex-row align-items-center justify-content-start">
        <i [class]="label.faIconClass"></i>&nbsp;&nbsp;
        <span class="">{{ label.infoText }}</span>
      </div>
    }
  </div>
</div>
